import { render, staticRenderFns } from "./manage-boqs.vue?vue&type=template&id=712ce6f0&scoped=true"
import script from "./manage-boqs.vue?vue&type=script&lang=js"
export * from "./manage-boqs.vue?vue&type=script&lang=js"
import style0 from "./manage-boqs.vue?vue&type=style&index=0&id=712ce6f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712ce6f0",
  null
  
)

export default component.exports